if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.mql = window.matchMedia('(min-width: 750px)');
        this.initialized = false;
      }

      connectedCallback() {
        if (this.initialized) return;

        requestAnimationFrame(() => {
          this.initializeGallery();
        });
      }

      initializeGallery() {
        if (this.initialized) return;

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        if (!this.elements.viewer || !this.elements.thumbnails) {
          return;
        }

        this.initialized = true;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {
            const button = mediaToSwitch.querySelector('button');

            if (!button) return;

            button.addEventListener('click', () => {
              this.setActiveMedia(mediaToSwitch.dataset.target, false);
            });
          });

        if (
          (this.dataset.desktopLayout || '').includes('thumbnail') &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const currentElement = event.detail?.currentElement;
        if (!currentElement) return;

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${currentElement.dataset.mediaId}"]`
        );

        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) return;

        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove('is-active');
          });

        activeMedia.classList.add('is-active');

        if (prepend) {
          if (activeMedia.parentElement.firstChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          const activeThumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

          if (
            activeThumbnail &&
            activeThumbnail.parentElement.firstChild !== activeThumbnail
          ) {
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
              behavior: 'smooth',
            });
          }

          const activeMediaRect = activeMedia.getBoundingClientRect();

          if (activeMediaRect.top <= -0.5) {
            window.scrollTo({
              top: activeMediaRect.top + window.scrollY,
              behavior: 'smooth',
            });
          }
        });

        this.playActiveMedia(activeMedia);

        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );

        if (!activeThumbnail) return;

        this.setActiveThumbnail(activeThumbnail);

        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!thumbnail || !this.elements.thumbnails) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => {
            element.removeAttribute('aria-current');
          });

        const button = thumbnail.querySelector('button');

        if (button) {
          button.setAttribute('aria-current', 'true');
        }

        if (
          typeof this.elements.thumbnails.isSlideVisible === 'function' &&
          this.elements.thumbnails.isSlideVisible(thumbnail, 10)
        ) {
          return;
        }

        if (this.elements.thumbnails.slider) {
          this.elements.thumbnails.slider.scrollTo({
            left: thumbnail.offsetLeft,
            behavior: 'smooth',
          });
        }
      }

      announceLiveRegion(activeItem, position) {
        if (!this.elements.liveRegion) return;

        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );

        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', 'false');
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );

          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', 'true');
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }

        const deferredMedia = activeItem.querySelector('.deferred-media');

        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event('preventHeaderReveal')
        );
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );

        this.elements.viewer.sliderItems.forEach((slide) => {
          slide.setAttribute('role', 'presentation');
        });
      }
    }
  );
}